import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.dev';
import { IKnowledgeMapping } from '../../@core/models/model';
import { BaseService } from '../../@core/services/base.service';
import { KNOWLEDGE_SCOPE } from '../models/contract-management.model';
import { IDocumentType } from '../models/settings.model';

export interface GetDocumentTypesParams {
    projectId?: string;
    type?: KNOWLEDGE_SCOPE;
}

export interface CreateKnowledgeMapping {
    fileIds: string[];
    kbStoreIds: string[];
    documentTypeId: string;
    projectId?: string;
    scope: KNOWLEDGE_SCOPE;
}

@Injectable({ providedIn: 'root' })
export class KnowledgeMappingService extends BaseService {

    constructor(
        protected override http: HttpClient
    ) {
        super(http);
    }

    apiUrl = environment.apiUrl + '/knowledge-mapping';

    getDocumentTypesForKnowledgeMapping(params: { scope: KNOWLEDGE_SCOPE, projectId?: string }) {
        return this.get<(IDocumentType & { mappingUpdatedAt: Date | null })[]>(this.apiUrl + '/document-types', params);
    }

    getKnowledgeMappingsByDocumentType(params: { documentTypeId: string, scope: KNOWLEDGE_SCOPE, project?: string }) {
        return this.get<IKnowledgeMapping[]>(this.apiUrl + '/', params);
    }

    createKnowledgeMappings(createData: CreateKnowledgeMapping) {
        return this.post<IKnowledgeMapping[]>(this.apiUrl + '/create', createData);
    }

    deleteKnowledgeMappings(payload: { mappingIds: string[], documentTypeId: string, scope: KNOWLEDGE_SCOPE, projectId?: string }) {
        return this.delete<{ deletedCount: number }>(this.apiUrl + '/delete', payload);
    }

    downloadKbAndFile(kbIds: string[], fileIds: string[]): Observable<Blob> {
        return this.http.post<Blob>(
            this.apiUrl + '/download-zip',
            { kb: kbIds, files: fileIds },
            { responseType: 'blob' as 'json' }
        );
    }

}
